// extracted by mini-css-extract-plugin
module.exports = {"demo01":"demo-section-module--demo01--2oxB_","demo02":"demo-section-module--demo02--oPFHQ"};